import React from "react"

import { Alert } from "@chakra-ui/react"

import ResetPassword from "@/components/ResetPassword"
import Message from "@/components/Message"
import AccountLayout from "@/components/AccountLayout"

export default function ResetPasswordView() {
  const [resetSuccess, setResetSuccess] = React.useState(null)
  const [resetError, setResetError] = React.useState(null)

  const gradientBox = (
    <ResetPassword
      setResetSuccess={setResetSuccess}
      setResetError={setResetError}
    />
  )

  const message = (
    <Message>
      {`Reset your Blind Insight password`}
      {`Please select a new password.`}
      {resetSuccess && (
        <Alert variant="standard" status="success">
          {resetSuccess}
        </Alert>
      )}
      {resetError && (
        <Alert variant="standard" status="error">
          {resetError}
        </Alert>
      )}
    </Message>
  )

  return <AccountLayout gradientBox={gradientBox} message={message} />
}
